import { SegmentProps } from './props';
import { Segment } from './Segment';

const HeaderSegment = (props: SegmentProps) => (
  <Segment {...props} fillColor="white" />
);

export { HeaderSegment };
